import { Amplify } from 'aws-amplify';

/**
 * Configures Amplify v6 with the Cognito User Pool and OAuth settings.
 * Must be called once before any Auth imports are used — called at app entry (main.tsx).
 *
 * Environment variables (set in .env.local for local dev; CI/CD injects from CDK outputs):
 *   VITE_COGNITO_USER_POOL_ID       — from AuthStack CfnOutput 'UserPoolId'
 *   VITE_COGNITO_CLIENT_ID          — from AuthStack CfnOutput 'UserPoolClientId'
 *   VITE_COGNITO_DOMAIN             — host only, e.g. slingshot-dev.auth.us-east-1.amazoncognito.com
 *   VITE_OAUTH_REDIRECT_SIGN_IN     — e.g. http://localhost:5173/oauth/callback
 *   VITE_OAUTH_REDIRECT_SIGN_OUT    — e.g. http://localhost:5173
 *   VITE_API_URL                    — from ApiStack CfnOutput 'ApiUrl'
 */
export function configureAmplify(): void {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
        userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
        loginWith: {
          email: true,
          oauth: {
            domain: import.meta.env.VITE_COGNITO_DOMAIN,
            scopes: ['email', 'openid', 'profile'],
            redirectSignIn: [import.meta.env.VITE_OAUTH_REDIRECT_SIGN_IN],
            redirectSignOut: [import.meta.env.VITE_OAUTH_REDIRECT_SIGN_OUT],
            responseType: 'code',
          },
        },
      },
    },
  });
}
